var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloodSlate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5.49646C2.47141 5.49646 3.66667 4 3.66667 4C3.66667 4 4.92996 5.39632 6.14963 5.49646C7.48962 5.60649 9 4 9 4C9 4 10.4449 5.46961 11.6667 5.49646C12.9181 5.52397 14.3333 4 14.3333 4C14.3333 4 15.8148 5.49646 17 5.49646",
    stroke: "#6E8CA0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.49646C2.47141 9.49646 3.66667 8 3.66667 8C3.66667 8 4.92996 9.39632 6.14963 9.49646C7.48962 9.60649 9 8 9 8C9 8 10.4449 9.46961 11.6667 9.49646C12.9181 9.52397 14.3333 8 14.3333 8C14.3333 8 15.8148 9.49646 17 9.49646",
    stroke: "#6E8CA0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13.4965C2.47141 13.4965 3.66667 12 3.66667 12C3.66667 12 4.92996 13.3963 6.14963 13.4965C7.48962 13.6065 9 12 9 12C9 12 10.4449 13.4696 11.6667 13.4965C12.9181 13.524 14.3333 12 14.3333 12C14.3333 12 15.8148 13.4965 17 13.4965",
    stroke: "#6E8CA0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloodSlate);
export default __webpack_public_path__ + "static/media/flood-slate.7ea7d9ab2a80576565ec93ae7f9f55b7.svg";
export { ForwardRef as ReactComponent };